import React, { useState } from "react";
import contactImage from "../assets/ContactUs.webp";
import "../components/Style.css";
import { Link as RouterLink } from "react-router-dom";
import banner from "../assets/banner.jpg";

const ContactUs = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      {/* Breadcrumb Banner */}
      <section
        className="breadcrumb-banner"
        style={{ backgroundImage: `url("${banner}")` }}
      >
        <div className="breadcrumb-content">
          <h1 className="breadcrumb-title">Contact Us</h1>
          <p className="breadcrumb-path">
            <RouterLink to="/" className="breadcrumb-link">
              Home
            </RouterLink>{" "}
            / Contact Us
          </p>
        </div>
      </section>

      {/* Main Contact Form Section */}
      <section className="contact-container">
        <div className="contact-card responsive-card">
          <div className="contact-image-wrapper">
            <img
              src={contactImage}
              alt="Contact"
              className="contact-us-image"
            />
          </div>
          <div className="contact-form-wrapper">
            <h2 className="contact-heading">Get in Touch</h2>
            <p className="contact-description">
              Have any questions or need help? Feel free to reach out to us
              using the form below.
            </p>

            {/* Formspree Form */}
            <form
              className="contact-form"
              action="https://formspree.io/f/xandngjk"
              method="POST"
            >
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                className="contact-input"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                className="contact-input"
                value={form.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                className="contact-input"
                value={form.message}
                onChange={handleChange}
                required
              />
              <button type="submit" className="contact-button">
                Send Message
              </button>
            </form>

          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
